const riot = require('riot');

riot.tag2('module-footer', '<div class="relative f fh flex-column py16"> <div class="absolute trbl0 s-full bg-sub"></div> <div class="relative f fh mb8"><a class="f fh flex-fixed px8 {item.class}" each="{item in sns}" href="{item.url}" target="_blank"><i class="block text-softgray icon-{item.label}"></i></a></div><small class="relative text-softgray fs11">© 2020 by YOH UENO</small> </div>', '', '', function(opts) {
    this.sns = [
      {label: 'twitter', class: 'pl8 pr7 pt1 fs22', url: 'https://twitter.com/yoh4046ue'},
      {label: 'instagram', class: 'px8 fs15', url: 'https://www.instagram.com/yoh_ueno.kemuri/?hl=ja'},
      {label: 'youtube', class: 'fs20', url: 'https://www.youtube.com/user/yoh4046ue'},
    ];
});